const STEPS = [
  {
    num: "01",
    title: "Sown on partner farms",
    body: "We source directly from certified organic farmers in Karnataka & Andhra, paying above-market — no middlemen, no mystery.",
    img: "https://images.pexels.com/photos/8818657/pexels-photo-8818657.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Farm",
  },
  {
    num: "02",
    title: "Sun-dried, slowly",
    body: "Chillies and turmeric are dried on open courtyards under the Deccan sun. No industrial heat — just patience and breeze.",
    img: "https://images.unsplash.com/photo-1723155182094-af2f63472d0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA4Mzl8MHwxfHNlYXJjaHwxfHxpbmRpYW4lMjBzcGljZXMlMjB0ZXh0dXJlfGVufDB8fHx8MTc3NjUyMzYzNXww&ixlib=rb-4.1.0&q=85",
    tag: "Dry",
  },
  {
    num: "03",
    title: "Hand-ground",
    body: "Hand-milled in small 4-kg batches so the oils stay bright and the colour stays deep. You can still see the grain, just like maa's masala.",
    img: "https://images.pexels.com/photos/5410418/pexels-photo-5410418.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Grind",
  },
  {
    num: "04",
    title: "Kraft-sealed, same week",
    body: "Hand-filled into food-grade kraft pouches within 5–7 days of grinding. Sealed with care, shipped with love.",
    img: "https://images.pexels.com/photos/7232507/pexels-photo-7232507.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    tag: "Seal",
  },
];

export const SpiceJourney = () => {
  return (
    <section
      id="journey"
      data-testid="journey-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-16">
          <div className="text-xs uppercase tracking-[0.3em] text-mo-terracotta mb-4">
            — From farm to pouch
          </div>
          <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl text-mo-ink leading-[1.05]">
            Four steps. <span className="italic text-mo-green">Zero shortcuts.</span>
          </h2>
          <p className="mt-5 text-mo-ink-soft max-w-xl">
            The reason a pinch of Maati smells different is simple — nothing in
            our process is rushed, and nothing is outsourced to a machine that
            forgets why it's making spice.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div
              key={s.num}
              data-testid={`journey-step-${i + 1}`}
              className="group relative"
            >
              <div className="relative overflow-hidden rounded-2xl aspect-[4/5]">
                <img
                  src={s.img}
                  alt={s.title}
                  className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#2C2520]/85 via-[#2C2520]/20 to-transparent" />
                <div className="absolute top-5 left-5 font-serif-display text-4xl text-[#D99026]">
                  {s.num}
                </div>
                <div className="absolute top-6 right-5 text-[10px] uppercase tracking-[0.22em] text-mo-cream/80 bg-mo-cream/15 backdrop-blur-sm px-3 py-1 rounded-full">
                  {s.tag}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-mo-cream">
                  <h3 className="font-serif-display text-2xl leading-tight mb-2">
                    {s.title}
                  </h3>
                  <p className="text-sm text-mo-cream/85 leading-relaxed">
                    {s.body}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
